const stateDefault =  {};

export default (state = stateDefault, action) => {
  switch (action.type){
    case 'SET_TEMP_FAV_SHOP':
      let newState = {...state};
      newState[action.shopId] = action.isFavorite;
      return newState;
    default:
      return state;
  }
};
